
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Que faut-il pour créer un site Internet ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Budget, connaissances techniques, conseils et outils, cet article vous explique tous les ingrédients d’un site Internet réussi.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Que faut-il pour créer un site Internet ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Budget, connaissances techniques, conseils et outils, cet article vous explique tous les ingrédients d’un site Internet réussi.",
        },
      ],
    };
  },
};
